export default __webpack_public_path__ + "static/media/Hair_9_M_C1.031cee08.svg";